module.exports = __webpack_public_path__ + "img/icon_status_-1@3x.a8c81cdb.png";